// store.js
import { getCookie } from '@/services/campaignService';
import Vuex from 'vuex';

export default new Vuex.Store({
  state: {
    // Your application state variables go here
    // For example:
    currentAdGroupName:'',
    currentTargetingType:'',
    campaignsApiData: null,
    getDefaultReport: [],
    addedKeywords: [],
    addGroupList: null,
    advancedReportBool : false,
    reportData:{},
    reportEntityId: '',
    enteredKeyword: null,
    savedReportsEditMode: false,
    sellerId: getCookie('sellerId'),
    campaignClass: 'Sponsored',
  },
  mutations: {
    // Mutation functions to modify state go here
    // For example:
    SET_CURRENT_AD_GROUP_NAME(state, data) {
      state.currentAdGroupName = data;
    },
    SET_CURRENT_TARGETING_TYPE(state, data) {
      state.currentTargetingType = data;
    },
    setAddedKeywords(state, data){
      state.addedKeywords = data;
    },
    setDefaultReport(state, data) {
      state.getDefaultReport = data;
    },
    SET_CAMPAIGN_API_DATA(state, data) {
        state.campaignsApiData = data;
    },
    SET_AD_GROUP_LIST(state, data) {
        state.addGroupList = data;
    },
    RESET_AD_GROUP_LIST(state) {
        state.addGroupList = [];
    },
    SET_ADVANCE_REPORT_BOOL(state, data) {
      state.advancedReportBool = data;
     },
    SET_REPORT_DATA(state, data) {
      state.reportData = data;
    },
    SET_REPORT_ENTITY_ID(state, data) {
      state.reportEntityId = data;
    },
    RESET_ADVANCE_REPORT_BOOL(state) {
      state.advancedReportBool = false;
     },
    RESET_REPORT_DATA(state) {
      state.reportData = {};
    },
    RESET_REPORT_ENTITY_ID(state) {
      state.reportEntityId = '';
    },
    updateAddedKeywords(state, newObj) {
      state.addedKeywords.push(newObj);
    },
    resetAddedKeywords(state) {
      state.addedKeywords = [];
    },
    SET_ENTERED_KEYWORD(state, data) {
      state.enteredKeyword = data;
    },
    SET_SAVED_REPORTS_EDIT_MODE(state, data) {
      state.savedReportsEditMode = data;
    },
    SET_SELLER_ID(state, data) {
      state.sellerId = data;
    },
    SET_CAMPAIGN_CLASS(state, data) {
      state.campaignClass = data;
    }
  },
  actions: {
    // Action functions to commit mutations go here
    // For example:
    setCurrentAdGroupName({ commit }, data) {
      commit('SET_CURRENT_AD_GROUP_NAME', data);
    },
    setCurrentTargetingType({ commit }, data) {
      commit('SET_CURRENT_TARGETING_TYPE', data);
    },
    setCampaignApiData({ commit }, data) {
        commit('SET_CAMPAIGN_API_DATA', data);
    },
    setAdGroupListData({ commit }, data) {
        commit('SET_AD_GROUP_LIST', data);
    },
    setAdvanceReportBool({ commit }, data) {
      commit('SET_ADVANCE_REPORT_BOOL', data);
    },
    setEnteredKeyword({ commit }, data) {
        commit('SET_ENTERED_KEYWORD', data);
    },
    setReportData({ commit }, data) {
      commit('SET_REPORT_DATA', data);
    },
    setReportEntityId({ commit }, data) {
     commit('SET_REPORT_ENTITY_ID', data);
    },
    setSavedReportsEditMode({ commit }, data) {
      commit('SET_SAVED_REPORTS_EDIT_MODE', data)
    },
    setSellerId({ commit }, data) {
      commit('SET_SELLER_ID', data)
    },
    resetAdGroupListData({ commit }) {
      commit('RESET_AD_GROUP_LIST');
   },
    resetAdvanceReportBool({ commit }) {
      commit('RESET_ADVANCE_REPORT_BOOL');
    },
    resetReportData({ commit }) {
      commit('RESET_REPORT_DATA');
    },
    resetReportEntityId({ commit }) {
     commit('RESET_REPORT_ENTITY_ID');
    },
    setCampaignClass({ commit }, data) {
      commit('SET_CAMPAIGN_CLASS', data);
    }
  },
  getters: {
    // Getter functions to access state go here
    // For example:
    // getUser: state => state.user,
  },
});
